(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["td-atp-faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var items = document.querySelectorAll('.faq-item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (this.open) {
          items.forEach(function (other) {
            if (other !== item) {
              other.open = false;
            }
          });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-product-bundle"] && !Shopify.designMode) return;
  try {
    
          class BundleSelector extends HTMLElement {
            max = 0;
            propertyName = 'Bundled items';
            blockId = 'bundle';
            inputs = null;
            details = null;
            _observer = null;
            _outsideClickHandler = null;

            connectedCallback() {
              this.max = parseInt(this.dataset.max ?? '') || 0;
              this.propertyName = this.dataset.propertyName || 'Bundled items';
              this.blockId = this.dataset.blockId || 'bundle';
              this.inputs = this.querySelectorAll('.bundle-selector__input');
              this.details = this.querySelector('.bundle-selector__dropdown');
              this.searchInput = this.querySelector('.bundle-selector__search-input');

              this.searchInput?.addEventListener('input', this._filterOptions.bind(this));
              this.details?.addEventListener('toggle', () => {
                if (this.searchInput) {
                  this.searchInput.value = '';
                  this._filterOptions();
                }
              });

              if (this.inputs.length === 0) return;

              this.variantSelects = this.querySelectorAll('.bundle-selector__variant-select');
              this.variantSelects.forEach((select) => {
                select.addEventListener('change', this._onVariantChange.bind(this));
              });

              this.inputs.forEach((input) => {
                input.addEventListener('change', this._onChange.bind(this));
              });

              this._outsideClickHandler = (event) => {
                const target = event.target;
                if (this.details?.open && (!(target instanceof Node) || !this.details.contains(target))) {
                  this.details.removeAttribute('open');
                }
              };
              document.addEventListener('click', this._outsideClickHandler);

              this._updateCount();
              this._syncProperties();
            }

            disconnectedCallback() {
              this._observer?.disconnect();
              this._observer = null;

              if (this._outsideClickHandler) {
                document.removeEventListener('click', this._outsideClickHandler);
                this._outsideClickHandler = null;
              }
            }

            _filterOptions() {
              const query = (this.searchInput?.value || '').trim().toLowerCase();
              this.inputs.forEach((input) => {
                const option = input.closest('.bundle-selector__option');
                if (!option) return;
                const title =
                  option.querySelector('.bundle-selector__item-title')?.textContent?.trim().toLowerCase() || '';
                option.classList.toggle('bundle-selector__option--hidden', query.length > 0 && !title.includes(query));
              });
            }

            _onChange(event) {
              if (this.max <= 0) {
                this._updateCount();
                this._syncProperties();
                return;
              }
              const checked = this.querySelectorAll('.bundle-selector__input:checked');
              if (checked.length > this.max) {
                const target = event.target;
                target.checked = false;
              }

              this._updateCount();
              this._syncProperties();
            }

            _onVariantChange(event) {
              const select = event.target;
              const option = select.closest('.bundle-selector__option');
              if (!option) return;

              const input = option.querySelector('.bundle-selector__input');
              if (!input) return;

              const selectedOption = select.options[select.selectedIndex];
              const newVariantId = selectedOption.value;
              const newPrice = selectedOption.dataset.price;
              const newTitle = selectedOption.dataset.title;

              input.dataset.variantId = newVariantId;
              input.dataset.variantTitle = newTitle;
              input.dataset.price = newPrice;

              this._syncProperties();
            }

            _updateCount() {
              const count = this.querySelectorAll('.bundle-selector__input:checked').length;
              const dots = this.querySelectorAll('.bundle-selector__dot');
              dots.forEach((dot, index) => {
                dot.classList.toggle('bundle-selector__dot--filled', index < count);
              });
              this._updateOptionsState();
              this._updateButtonState(count);
              this._updatePlaceholder(count);
            }

            _updateButtonState(count) {
              const container = this.closest('[data-testid="product-information"]');
              const form = container?.querySelector('form[data-type="add-to-cart-form"]');
              const button = form?.querySelector('.cp-bundle__buy-btn');
              if (!button) return;
              const shouldRequire = this.max > 0;
              button.disabled = shouldRequire && count < this.max;
            }

            _updateOptionsState() {
              if (this.max <= 0) return;
              const count = this.querySelectorAll('.bundle-selector__input:checked').length;
              const atLimit = count >= this.max;
              this.inputs.forEach((input) => {
                const option = input.closest('.bundle-selector__option');
                if (!option) return;
                if (option.classList.contains('bundle-selector__option--disabled')) return;
                const limited = atLimit && !input.checked;
                option.classList.toggle('bundle-selector__option--limit', limited);
                option.setAttribute('aria-disabled', limited ? 'true' : 'false');
                input.disabled = limited;
              });
            }

            _updatePlaceholder(count) {
              const placeholder = this.querySelector('.cp-bundle__trigger-placeholder');
              if (!placeholder) return;
              const label = this.dataset.selectedLabel || 'selected';
              if (count > 0) {
                placeholder.textContent = `${count} ${label}`;
              } else {
                placeholder.textContent = placeholder.dataset.defaultText || '';
              }
            }

            _getForm() {
              const container = this.closest('[data-testid="product-information"]');
              if (!container) {
                this._log(
                  'warn',
                  'no product-information container found; aborting sync to avoid touching the wrong form'
                );
                return null;
              }
              return container.querySelector('form[data-type="add-to-cart-form"]') || null;
            }

            _syncProperties() {
              const form = this._getForm();
              if (!form) return;

              this._observeForm(form);

              let hidden = form.querySelector(`input[data-bundle-property="${this.blockId}"]`);
              let hiddenVariants = form.querySelector(`input[data-bundle-property-variants="${this.blockId}"]`);
              const selected = Array.from(this.inputs).filter((input) => input.checked);

              if (selected.length === 0) {
                if (hidden) hidden.remove();
                if (hiddenVariants) hiddenVariants.remove();
                this.dataset.bundleState = 'empty';
                return;
              }

              const ids = selected
                .map((input) => input.dataset.productId || '')
                .filter(Boolean)
                .join(',');

              const variants = selected
                .map((input) => input.dataset.variantTitle || '')
                .filter(Boolean)
                .join(',');

              if (!ids) {
                if (hidden) hidden.remove();
                if (hiddenVariants) hiddenVariants.remove();
                return;
              }

              if (!hidden) {
                hidden = document.createElement('input');
                hidden.type = 'hidden';
                hidden.dataset.bundleProperty = this.blockId;
                hidden.name = `properties[${this.propertyName}]`;
                form.appendChild(hidden);
              }
              hidden.value = ids;

              if (!hiddenVariants) {
                hiddenVariants = document.createElement('input');
                hiddenVariants.type = 'hidden';
                hiddenVariants.dataset.bundlePropertyVariants = this.blockId;
                hiddenVariants.name = `properties[${this.propertyName} variants]`;
                form.appendChild(hiddenVariants);
              }
              hiddenVariants.value = variants;

              this.dataset.bundleState = `synced:${selected.length}`;
            }

            _observeForm(form) {
              if (this._observer) return;
              this._observer = new MutationObserver(() => this._syncProperties());
              this._observer.observe(form, { childList: true, subtree: true });
            }

            _log(level, message) {
              if (window.Shopify?.designMode) {
                console[level](`[bundle-selector]`, message, this);
              }
            }
          }

          if (!customElements.get('bundle-selector')) {
            customElements.define('bundle-selector', BundleSelector);
          }

          const syncBundleProperties = (form) => {
            if (!form.matches('form[data-type="add-to-cart-form"]')) return;

            const container = form.closest('[data-testid="product-information"]');
            if (!container) return;

            const selectors = container.querySelectorAll('bundle-selector');
            selectors.forEach((selector) => selector._syncProperties());
          };

          document.addEventListener(
            'click',
            (event) => {
              const target = event.target;
              if (!(target instanceof Element)) return;

              const form = target.closest('form[data-type="add-to-cart-form"]');
              if (form) syncBundleProperties(form);
            },
            { capture: true }
          );

          document.addEventListener(
            'submit',
            (event) => {
              const target = event.target;
              if (target instanceof Element) syncBundleProperties(target);
            },
            { capture: true }
          );
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-test-dd"] && !Shopify.designMode) return;
  try {
    
          class BundleSelector extends HTMLElement {
            max = 0;
            propertyName = 'Bundled items';
            blockId = 'bundle';
            inputs = null;
            details = null;
            _observer = null;
            _outsideClickHandler = null;

            connectedCallback() {
              this.max = parseInt(this.dataset.max ?? '') || 0;
              this.propertyName = this.dataset.propertyName || 'Bundled items';
              this.blockId = this.dataset.blockId || 'bundle';
              this.inputs = this.querySelectorAll('.bundle-selector__input');
              this.details = this.querySelector('.bundle-selector__dropdown');
              this.searchInput = this.querySelector('.bundle-selector__search-input');

              this.searchInput?.addEventListener('input', this._filterOptions.bind(this));
              this.details?.addEventListener('toggle', () => {
                if (this.searchInput) {
                  this.searchInput.value = '';
                  this._filterOptions();
                }
              });

              if (this.inputs.length === 0) return;

              this.variantSelects = this.querySelectorAll('.bundle-selector__variant-select');
              this.variantSelects.forEach((select) => {
                select.addEventListener('change', this._onVariantChange.bind(this));
              });

              this.inputs.forEach((input) => {
                input.addEventListener('change', this._onChange.bind(this));
              });

              this._outsideClickHandler = (event) => {
                const target = event.target;
                if (this.details?.open && (!(target instanceof Node) || !this.details.contains(target))) {
                  this.details.removeAttribute('open');
                }
              };
              document.addEventListener('click', this._outsideClickHandler);

              this._updateCount();
              this._syncProperties();
            }

            disconnectedCallback() {
              this._observer?.disconnect();
              this._observer = null;

              if (this._outsideClickHandler) {
                document.removeEventListener('click', this._outsideClickHandler);
                this._outsideClickHandler = null;
              }
            }

            _filterOptions() {
              const query = (this.searchInput?.value || '').trim().toLowerCase();
              this.inputs.forEach((input) => {
                const option = input.closest('.bundle-selector__option');
                if (!option) return;
                const title =
                  option.querySelector('.bundle-selector__item-title')?.textContent?.trim().toLowerCase() || '';
                option.classList.toggle('bundle-selector__option--hidden', query.length > 0 && !title.includes(query));
              });
            }

            _onChange(event) {
              if (this.max <= 0) {
                this._updateCount();
                this._syncProperties();
                return;
              }
              const checked = this.querySelectorAll('.bundle-selector__input:checked');
              if (checked.length > this.max) {
                const target = event.target;
                target.checked = false;
              }

              this._updateCount();
              this._syncProperties();
            }

            _onVariantChange(event) {
              const select = event.target;
              const option = select.closest('.bundle-selector__option');
              if (!option) return;

              const input = option.querySelector('.bundle-selector__input');
              if (!input) return;

              const selectedOption = select.options[select.selectedIndex];
              const newPrice = selectedOption.dataset.price;
              const newTitle = selectedOption.dataset.title;

              input.dataset.variantTitle = newTitle;
              input.dataset.price = newPrice;

              this._syncProperties();
            }

            _updateCount() {
              const count = this.querySelectorAll('.bundle-selector__input:checked').length;
              const dots = this.querySelectorAll('.bundle-selector__dot');
              dots.forEach((dot, index) => {
                dot.classList.toggle('bundle-selector__dot--filled', index < count);
              });
              this._updateOptionsState();
              this._updateButtonState(count);
              this._updatePlaceholder(count);
            }

            _updateButtonState(count) {
              const container = this.closest('[data-testid="product-information"]');
              const form = container?.querySelector('form[data-type="add-to-cart-form"]');
              const button = form?.querySelector('.cp-bundle__buy-btn');
              if (!button) return;
              const shouldRequire = this.max > 0;
              button.disabled = shouldRequire && count < this.max;
            }

            _updateOptionsState() {
              if (this.max <= 0) return;
              const count = this.querySelectorAll('.bundle-selector__input:checked').length;
              const atLimit = count >= this.max;
              this.inputs.forEach((input) => {
                const option = input.closest('.bundle-selector__option');
                if (!option) return;
                if (option.classList.contains('bundle-selector__option--disabled')) return;
                const limited = atLimit && !input.checked;
                option.classList.toggle('bundle-selector__option--limit', limited);
                option.setAttribute('aria-disabled', limited ? 'true' : 'false');
                input.disabled = limited;
              });
            }

            _updatePlaceholder(count) {
              const placeholder = this.querySelector('.cp-bundle__trigger-placeholder');
              if (!placeholder) return;
              const label = this.dataset.selectedLabel || 'selected';
              if (count > 0) {
                placeholder.textContent = `${count} ${label}`;
              } else {
                placeholder.textContent = placeholder.dataset.defaultText || '';
              }
            }

            _getForm() {
              const container = this.closest('[data-testid="product-information"]');
              if (!container) {
                this._log(
                  'warn',
                  'no product-information container found; aborting sync to avoid touching the wrong form'
                );
                return null;
              }
              return container.querySelector('form[data-type="add-to-cart-form"]') || null;
            }

            _syncProperties() {
              const form = this._getForm();
              if (!form) return;

              this._observeForm(form);

              let hidden = form.querySelector(`input[data-bundle-property="${this.blockId}"]`);
              let hiddenVariants = form.querySelector(`input[data-bundle-property-variants="${this.blockId}"]`);
              const selected = Array.from(this.inputs).filter((input) => input.checked);

              if (selected.length === 0) {
                if (hidden) hidden.remove();
                if (hiddenVariants) hiddenVariants.remove();
                this.dataset.bundleState = 'empty';
                return;
              }

              const ids = selected
                .map((input) => input.value || '')
                .filter(Boolean)
                .join(',');

              const variants = selected
                .map((input) => input.dataset.variantTitle || '')
                .filter(Boolean)
                .join(',');

              if (!ids) {
                if (hidden) hidden.remove();
                if (hiddenVariants) hiddenVariants.remove();
                return;
              }

              if (!hidden) {
                hidden = document.createElement('input');
                hidden.type = 'hidden';
                hidden.dataset.bundleProperty = this.blockId;
                hidden.name = `properties[${this.propertyName}]`;
                form.appendChild(hidden);
              }
              hidden.value = ids;

              if (!hiddenVariants) {
                hiddenVariants = document.createElement('input');
                hiddenVariants.type = 'hidden';
                hiddenVariants.dataset.bundlePropertyVariants = this.blockId;
                hiddenVariants.name = `properties[${this.propertyName} variants]`;
                form.appendChild(hiddenVariants);
              }
              hiddenVariants.value = variants;

              this.dataset.bundleState = `synced:${selected.length}`;
            }

            _observeForm(form) {
              if (this._observer) return;
              this._observer = new MutationObserver(() => this._syncProperties());
              this._observer.observe(form, { childList: true, subtree: true });
            }

            _log(level, message) {
              if (window.Shopify?.designMode) {
                console[level](`[bundle-selector]`, message, this);
              }
            }
          }

          if (!customElements.get('bundle-selector')) {
            customElements.define('bundle-selector', BundleSelector);
          }

          const syncBundleProperties = (form) => {
            if (!form.matches('form[data-type="add-to-cart-form"]')) return;

            const container = form.closest('[data-testid="product-information"]');
            if (!container) return;

            const selectors = container.querySelectorAll('bundle-selector');
            selectors.forEach((selector) => selector._syncProperties());
          };

          document.addEventListener(
            'click',
            (event) => {
              const target = event.target;
              if (!(target instanceof Element)) return;

              const form = target.closest('form[data-type="add-to-cart-form"]');
              if (form) syncBundleProperties(form);
            },
            { capture: true }
          );

          document.addEventListener(
            'submit',
            (event) => {
              const target = event.target;
              if (target instanceof Element) syncBundleProperties(target);
            },
            { capture: true }
          );
        
  } catch(e) { console.error(e); }
})();
})();
